import script from "./UserOTP.vue?vue&type=script&setup=true&lang=js"
export * from "./UserOTP.vue?vue&type=script&setup=true&lang=js"

import "./UserOTP.vue?vue&type=style&index=0&id=75df55e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75df55e0"]])

export default __exports__